export default __webpack_public_path__ + "static/media/mp-placeholder.3cb7eee4.jpg";